module.exports = __webpack_public_path__ + "static/media/calendar.2a603df6.svg";